module.exports = __webpack_public_path__ + "static/img/modelAltiumFilesManage.9ee6acc0.png";